import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface ReviewKeywordType {
	keyword: string;
	keywordCnt: number;
}

interface ReviewSummaryType {
	reviewCnt: number;
	scoreAvg: number;
	companion: string;
	companionNm: string;
	companionAttr1: string;
	companionAttr2: string;
	keywordList: ReviewKeywordType[];
}

/** ```
 * 이용 약관 조회
 *   `/portal/product/${goodsCd}/review/summary`
 * parameter
 *   `policyCodeIdHi` 공통코드 상위 ID
 * ```*/
const key = `useReviewSummary`;
const getPath = (goodsCd?: string): string | null => {
	if (!goodsCd) return "";
	return `${publicRuntimeConfig.ENV_PORTAL_API_URL}/portal/product/${goodsCd}/review/summary`;
};

/** ```
 * 이용 약관 조회
 *   `/portal/product/${goodsCd}/review/summary`
 * parameter
 *   `policyCodeIdHi` 공통코드 상위 ID
 * ```*/
const useReviewSummary = (goodsCd?: string, options?: Partial<UseQueryOptions<Response<ReviewSummaryType>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(goodsCd)],
		queryFn: () => useConfigureAxios({url: getPath(goodsCd)}).then(r => r.data),
		gcTime: Infinity,
		staleTime: Infinity,
		throwOnError: false,
		...options,
	});

export default useReviewSummary;
export {getPath, key};
export type {ReviewSummaryType, ReviewKeywordType};
